import React from 'react';
import styles from './styles';

interface EmptyStateProps {
  title?: string;
  subTitle?: string;
}

const EmptyState: React.FC<EmptyStateProps> = (props) => {
  const { title, subTitle } = props;

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img alt="" src="http://cdn.realpage.com/images/illustrations/generic.svg" />
      </div>
      <div>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subTitle}</span>
      </div>
    </div>
  );
};

export default EmptyState;
